import { Center, Spinner, Text } from "@chakra-ui/react";

const NoResults = ({
  message,
  loading,
}: {
  message: string;
  loading?: boolean;
}) => {
  return (
    <Center flexDir="column" minH="260px">
      {loading ? (
        <Spinner />
      ) : (
        <Text fontSize="14px" color="#515355" mb="20px">
          {message}
        </Text>
      )}
    </Center>
  );
};

export default NoResults;
